import flat from "flat";

export const columnGroups = [
  {
    title: "Details",
    columns: [
      "details_maxSwitchBoardConnections",
      "details_extensionLength",
      "details_emergencyAddress_freeForm",
      "details_nomadicCustomerId",
    ],
  },
];
export const columnTitles = {
  pbxId: "PBX ID",
  region: "Region",
  status: "Status",
  name: "Name",
  locale: "Locale",
  timezoneId: "Timezone ID",
  dialPlanName: "Dial Plan Name",
  dialPlanRuleSetName: "Dial Plan Rule Set",
  details_maxSwitchBoardConnections: "Max Switch Board Connections",
  details_emergencyAddress_freeForm: "Emergency Address",
  details_extensionLength: "Extension Length",
  details_nomadicCustomerId: "Nomadic Customer Id",
};

export const visibleColumns = () => Array.from(Object.keys(columnTitles));

export const REGIONS = ["USA", "CAN", "EU", "GBR", "AUS", "IN", "CHN"];

export const newPbx = () => ({
  region: REGIONS[0],
  name: null,
  customerId: null,
  timezoneId: null,
  details: {
    classType: "SMB",
    type: "VIRTUAL_OFFICE",
    maxSwitchBoardConnections: null,
    emergencyAddress: {
      addressFormat: null,
      freeForm: null,
      addressLine: null,
      streetName: null,
      streetNameSuffix: null,
      streetNumber: null,
      unit: null,
      city: null,
      state: null,
      county: null,
      country: null,
      postal: null,
      zip4: null,
      streetNumberSuffix: null,
      validationSource: null,
      verified: true,
      lastAddressUpdatedTime: null,
    },
    extensionLength: null,
    nomadicCustomerId: null,
  },
  locale: "en-US",
  dialPlanName: "NANP",
  dialPlanRuleSetName: "INTERNATIONAL",
});

export const flatten = (pbx) => {
  if (!pbx.details.emergencyAddress) {
    pbx.details.emergencyAddress = { freeForm: null };
  }
  return flat(pbx, { delimiter: "_" });
};

export const unflatten = (pbx) => {
  return flat.unflatten(pbx, { delimiter: "_" });
};
